import { createContext, useCallback, useContext, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { lastCompleteMonth, shiftMonth } from './scope';

/**
 * THE MONTH A REPORT IS ABOUT, kept in the address (`?month=2026-10`) so it
 * survives a change of tab and a reload. It used to be state inside each
 * report, which is how "Revenue — October" turned into "Insurance — September"
 * with nothing on the page to say why.
 *
 * A surface that wants a different starting month (the accountant reads the
 * current month; the manager reads the last complete one) provides it through
 * `ReportMonthDefault`; with nothing provided it is the last complete month.
 */
export const ReportMonthDefault = createContext<string | null>(null);

export function useReportMonth() {
  const [params, setParams] = useSearchParams();
  const dflt = useContext(ReportMonthDefault) ?? lastCompleteMonth();
  const asked = params.get('month') ?? '';
  const month = /^\d{4}-(0[1-9]|1[0-2])$/.test(asked) ? asked : dflt;
  const setMonth = useCallback(
    (next: string) => {
      const p = new URLSearchParams(params);
      p.set('month', next);
      setParams(p, { replace: true });
    },
    [params, setParams],
  );
  const [compare, setCompare] = useState(() => shiftMonth(month, -1));
  return { month, setMonth, compare, setCompare };
}
